<template>
    <el-container class="temp-strategy_1">
        <el-main>
            <div class="temp-title column-header">
                <span>临时策略</span>
            </div>
            <el-table style="width: 100%;" :data="tableData">
                <el-table-column v-for="(title, index) in columnHeader" :key="'table_'+index"
                :prop="title.key" :label="title.name" :width="title.key == 'edit'?'400':'auto'">
                    <template slot-scope="scope">
                        <span  v-if="title.key == 'edit'">
                            <el-switch v-model="switchManualFlag['is_manual'+scope.row.id]"
                            active-text="手动补仓"
                            inactive-text="自动补仓"
                            active-color="#1aa094"
                            inactive-color="#4c4c4c"
                            @change="changeToManual($event, scope.row)"></el-switch>
                            <span class="btn__style" @click="showOpenDialog(scope.row)">执行交易</span>
                            <el-dropdown trigger="click">
                                <span class="btn__style">操作 <i class="el-icon-arrow-down el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="showEditDialog(scope.row)">编辑</el-dropdown-item>
                                    <!-- <el-dropdown-item @click.native="showOpenDialog(scope.row)">手动交易</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                    <span v-else-if="title.key == 'manual_ratio'" :style="{'color': scope.row[title.key] == '1'? '#1aa094': '#db5634'}">{{scope.row[title.key] == '1'? '看多': '看空'}}</span>
                        <span v-else-if="title.key == 'loss_value' || title.key == 'surplus_value'">{{(scope.row[title.key]).toFixed(2)}}%</span>
                        <span v-else-if="title.key == 'state'" class="temp-strategy_status"
                        :style="{'background-color': scope.row[title.key] == '1'?'#1aa094':'#db5634'}" >{{strategeStatus(scope.row[title.key])}}</span>
                        <span v-else>{{scope.row[title.key]}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 编辑框 -->
            <el-dialog title="编辑策略" :visible.sync="editDialogFlag" width="510px">
                <el-form label-width="130px" :model="dialogData">
                    <el-form-item label="apiID">
                        <el-input v-model="dialogData.apiId"></el-input>
                    </el-form-item>
                    <el-form-item label="方向">
                        <el-switch v-model="dialogData.manualRatio"
                        active-text="看多" inactive-text="看空" 
                        ></el-switch>
                    </el-form-item>
                    <el-form-item label="运行状态">
                        <el-switch v-model="dialogData.state"
                        active-text="运行" inactive-text="停止"></el-switch>
                    </el-form-item>
                    <el-form-item label="止损(%)">
                        <el-input v-model="dialogData.lossValue"></el-input>
                    </el-form-item>
                    <el-form-item label="止盈(%)">
                        <el-input v-model="dialogData.surplusValue"></el-input>
                    </el-form-item>
                    <el-form-item label="最大杠杆倍数">
                        <el-input v-model="dialogData.max_ratio"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editDialogFlag = false">取 消</el-button>
                    <el-button type="primary" @click="dialogSubmit">确 定</el-button>
                </div>
            </el-dialog>
            
            <!-- 手动交易 -->
            <ManulDialog ref="manulDialog" :type="'temp'"/>
        </el-main>
    </el-container>
</template>

<script>
import { get, post } from "@/api/index";
import { mapState } from "vuex";
import ManulDialog from "@/components/unilateral/Unilateral-manul.vue";

export default {
    components: {
        ManulDialog
    },
    data: function () {
        return {
            columnHeader: [
                {name: '序列ID', key: 'id'},
                {name: '绑定api', key: 'api'},
                {name: '币种', key: 'currency'},
                {name: '手动方向', key: 'manual_ratio'},
                {name: '信号比值', key: 'strategy_ratio'},
                {name: '持仓成本', key: 'cost'},
                {name: '止损', key: 'loss_value'},
                {name: '止盈', key: 'surplus_value'},
                {name: '最大杠杆倍数', key: 'max_ratio'},
                {name: '运行状态', key: 'state'},
                {name: '操作', key: 'edit'},
            ],
            tableData: [],
            editDialogFlag: false,
            dialogData: {},
            switchManualFlag: {},
            tempSocket: {},
            manualFlag: false,
            apiCurrentData: {}
            
        }
    },
    mounted() {
        this.getStrategyList();
        this.initWebSocket();
    },
    computed: {
        ...mapState([
            // "tradeTypeObj"
        ])
    },
    methods: {
        getStrategyList() {
            var url = this.$url_temp+'/get/data';
            get(url).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                    for (let [key, value] of res.data.entries()) {
                        this.switchManualFlag['is_manual'+value.id] = value.is_manual == 1 ? true: false;
                    }
                } else {
                    this.$notify.error({
                        title: '提示',
                        message: res.info,
                        offset: 100
                    })
                }
            })
        },

        strategeStatus(state) {
            if (state == '0') {// 停止
                return '停止';
            } else if (state == '1') {// 运行
                return '运行';
            }
        },

        showEditDialog(data) {// 打开编辑框
            this.dialogData = {
                id: data.id,
                apiId: data.aid,
                manualRatio: this.transformToBool(data.manual_ratio),
                state: this.transformToBool(data.state),
                lossValue: data.loss_value,
                surplusValue: data.surplus_value,
                max_ratio: data.max_ratio
            }
            this.editDialogFlag = true;
        },

        dialogSubmit() {// dialog 提交
            let param = {
                id: this.dialogData.id,
                apiId: this.dialogData.apiId,
                manualRatio: this.dialogData.manualRatio ? 1 : -1,
                state: this.dialogData.state ? 1 : 0,
                lossValue: Number(this.dialogData.lossValue),
                surplusValue: Number(this.dialogData.surplusValue),
                maxRatio: this.dialogData.max_ratio
            }
            let url = this.$url_temp+'/update/strategy';

            post(url, param).then(res => {
                if (res.code == 200) {
                    this.getStrategyList();
                    this.editDialogFlag = false;
                }
                
                this.$notify.info({
                    title: '提示',
                    message: res.info,
                    offset: 100,
                    duration: 2000
                })
            });
        },

        transformToBool(flag) {
            let data = String(flag);
            if (data == '1') {
                return true;
            } else if (data == '-1') {
                return false;
            } else if (data == '0') {
                return false;
            }
        },

        changeToManual(e, data) {// 转为手动
            let tip_word = '';
            String(e) == '1'?tip_word = '是否设置为手动':tip_word = '是否设置为自动';

            this.$confirm(tip_word, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url = this.$url_temp+'/update/manual';
                let param = {
                    id: data.id,
                    state: Number(e)
                };

                post(url, param).then(res => {
                    if (res.code === 200) {
                        this.getStrategyList();  
                    } 
                    this.$notify.info({
                        title: '提示',
                        message: res.info,
                        offset: 100,
                        duration: 2000
                    })
                });
            })
            
        },

        initWebSocket() {// 初始化 websocket
            var url = 'ws://107.149.104.7:8026/web/data';
            if (!this.tempSocket.skt) {
                this.tempSocket.skt = new WebSocket(url);
            }
            this.createSocketFnc();
        },

        createSocketFnc() {// socket 方法
            this.tempSocket.skt.onopen = () => {
                console.log('WebSocket connect successfully');
            };

            this.tempSocket.skt.onmessage = res => {// websocket 接收函数
                // console.log(res.data);
                var rut = JSON.parse(res.data);
                this.tableData = rut;
                for (let [key, value] of rut.entries()) {
                    this.switchManualFlag['is_manual'+value.id] = value.is_manual == 1 ? true: false;
                }
            };

            this.tempSocket.skt.onclose = function (err) {// 关闭调用
                console.warn('Websocket is closed! Error: '+ err);
            }
        },

        showOpenDialog(data) {// 打开手动交易dialog窗口
            let manulDialog = this.$refs.manulDialog;
            this.apiCurrentData = data;
            console.log('open', data)
            if (manulDialog) {
                manulDialog.showDialog();
                manulDialog.setDialogData(data);
            }
        }
    }

}
</script>

<style lang="scss">
.temp-strategy_1 {

    .temp-strategy_status {
        padding: 0px 10px;
        color: #fff;
        border-radius: 3px;
        display: inline-block;
        font-size: 12px;
    }
    .manual_btn {
        margin-left: 10px;
    }

    .el-table th, .el-table tr {
        background-color: #2a2d2e;
    }
    .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #252425;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before {
        background-color: #252425;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: #1e1e1e;
    }
    .el-table__empty-block {
        background-color: #2a2d2e;
    }
    table .el-switch {
        margin-left: 10px;
    }
    table .el-switch__label.is-active {
        color: #1aa094;
    }
    table .el-switch__label {
        color: #606266;
        font-size: 12px;
    }
    table .el-switch__core:after {
        background-color: #cccac9;
    }
    table .btn__style {
        margin: 0 5px;
    }

    // dialog
    .el-dialog .el-dialog__header {
        background-color: transparent !important;
        border-bottom: 1px solid #eaeaea;
        padding: 16px 0 !important;
    }
    .el-dialog__header .el-dialog__headerbtn {
        top: 10px;
        font-size: 24px;
    }
    .el-form-item__content {
        text-align: left;
    }
    .el-form-item__label {
        padding-left: 24px;
    }
}
</style>
